import { useDispatch } from 'react-redux';
import { setPreviewImage } from '../../redux/aiInsights/ai.actions';

export default function InsightExpanded({ insight }) {
  const dispatch = useDispatch();
  //console.log('expand', insight);

  return (
    <div className="text-left">
      <p className="text-gray-700 text-left">{insight.genai_insight}</p>
     <div className="mt-3 text-left">
        {insight.links?.map((item) => (
          <span
            key={item.id}
            onClick={() => item.onNavigate(item.id)}
            className="text-blue-600 underline cursor-pointer block mb-1 text-left">
            {item.genai_insight}
          </span>
        ))}
      </div>

      {insight.graph_path?.length > 0 && (
        <div className="d-flex flex-wrap gap-2 mt-2">
          {insight.graph_path.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt="Insight graph"
              onClick={() => dispatch(setPreviewImage(insight.id, img))}

              className="img-thumbnail"
              style={{
                width: '120px',
                height: '80px',
                cursor: 'pointer'
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
